// Toggle the mobile/iPad-portrait nav drawer.
// The burger is an <a> with no href; preventDefault() keeps the URL clean.
// The CSS in nav.css responds to body.gh-head-open to reveal the drawer.
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    if (!burgerButton) return;
    burgerButton.addEventListener('click', function (event) {
        event.preventDefault();
        document.body.classList.toggle('gh-head-open');
    });
}
